import classNames from 'classnames';
import moment from 'moment-timezone';
import * as React from 'react';
import { ErrorCircleIcon, WarningIcon } from '../Components/Icons';
import { MedicationExpiry, MedicationStatus } from '../Contracts/MedicationModels';
import { duration, ValidDateFormats } from '../Shared/DateUtilities';
import { expiredRowIcon, warningRowIcon } from '../Styles/Colours';
import styles from './MedicationSummaryExpiryCard.module.css';
export var MedicationSummaryExpiryCard = function (props) {
    var _a;
    var expired = props.medicationExpiry === MedicationExpiry.Expired;
    var aboutToExpire = props.medicationExpiry === MedicationExpiry.AboutToExpire;
    var stopped = props.medicationStatus === MedicationStatus.Stopped;
    var inDate = props.medicationExpiry === MedicationExpiry.InDate;
    var noExpiry = props.medicationExpiry === MedicationExpiry.NoExpiry;
    if (!(stopped || inDate || noExpiry || expired || aboutToExpire) || (props.isChartDuration && stopped)) {
        return null;
    }
    var courseExpires = moment(props.medicationExpiresOn).format(ValidDateFormats.DisplayWithHyphen);
    if (!props.isChartDuration) {
        if (stopped || inDate || noExpiry) {
            return React.createElement(React.Fragment, null, props.medicationExpiresOn && courseExpires);
        }
    }
    var expiryClasses = classNames(styles.expiryText, (_a = {},
        _a[styles.expired] = expired,
        _a[styles.warning] = aboutToExpire,
        _a));
    return (React.createElement("div", { className: styles.expiryCard },
        !props.isChartDuration && React.createElement("div", { className: styles.dateText }, courseExpires),
        expired && (React.createElement("div", { className: styles.expiryText },
            React.createElement(ErrorCircleIcon, { size: '16', color: expiredRowIcon, className: styles.expiryIcon }),
            React.createElement("span", { className: expiryClasses }, "Expired"))),
        aboutToExpire && (React.createElement("div", { className: styles.expiryText },
            React.createElement(WarningIcon, { size: '16', color: warningRowIcon, className: styles.expiryIcon }),
            React.createElement("span", { className: expiryClasses }, duration(moment(props.medicationExpiresOn, ValidDateFormats.IsoFormat), moment()) + " left")))));
};
